// Registro local de íconos SVG para los módulos del sidebar de Calypso
// Delivery. La ruta se resuelve por el primer segmento del `route` del
// `MenuItem` (ej: `viajes/gestion-viajes` → `viajes`), que coincide con los
// paths de nivel superior declarados en `app.routes.ts`.

import { MenuItem } from '../../../core/menu/domain/menu-item.model';

/** Caminos SVG `d` por módulo (viewBox 0 0 24 24, stroke-based). */
export const MODULE_ICON_PATHS: Record<string, string> = {
  administrador:
    'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z',
  documentos:
    'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z',
  viajes:
    'M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7',
  contabilidad:
    'M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
  transporte:
    'M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0',
  locaciones:
    'M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z M15 11a3 3 0 11-6 0 3 3 0 016 0z',
};

/** Ícono de reserva (grilla 2x2) cuando el módulo no tiene un path registrado. */
export const DEFAULT_ICON_PATH =
  'M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z';

/**
 * Devuelve el `d` SVG para el ícono de un módulo del menú:
 * - Si `icon` ya llega como un path SVG (empieza con el comando `M`), se
 *   respeta el valor provisto por el backend.
 * - Si no, se resuelve por el primer segmento de `route` contra
 *   `MODULE_ICON_PATHS`.
 * - Si nada matchea, cae en `DEFAULT_ICON_PATH` (nunca devuelve string vacío).
 */
export function moduleIconPath(item: Pick<MenuItem, 'route' | 'icon'>): string {
  if (item.icon && item.icon.trimStart().startsWith('M')) {
    return item.icon;
  }

  const segment = item.route.replace(/^\/+/, '').split('/')[0]?.toLowerCase() ?? '';
  return MODULE_ICON_PATHS[segment] ?? DEFAULT_ICON_PATH;
}
